import { HTTP } from '@/api/http-common-velaeasy'

export default {
  getMemberToken (callback, param) {
    HTTP.post('rpshop-members-controller.php', param).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getMemberInfo (callback, param) {
    HTTP.post('rpshop-members-controller.php', param).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getMemberUrl () {
    return HTTP.defaults.baseURL + 'rpshop-members-controller.php'
  },

  getConsent (callback, param) {
    HTTP.post('rpshop-consent-controller.php', param).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getDefaultPolicy (callback) {
    HTTP.get('../views/popup-policy.php').then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/velaeasy/index.js